import { Component, OnInit } from "@angular/core";
import { AuthenticationService } from '../../services/auth.service';
import { ITrialService } from '../../services/Trial/trial.service.interface';
import { Router } from '@angular/router';

@Component({
  selector: "auth-callback",
  templateUrl: './authCallback.component.html',
  styleUrls: ['./authCallback.component.scss']
})

export class AuthCallbackComponent implements OnInit {

  trialService: ITrialService;

  constructor(private authService: AuthenticationService, trialService: ITrialService, private router: Router) {
    this.trialService = trialService;
  }

  ngOnInit() {
    this.authService.completeAuthentication().then(result => {
      let orgPrefix = localStorage.getItem("orgPrefix");
      let userId = localStorage.getItem("userId");



      this.trialService.enablePinnacle(orgPrefix, userId).subscribe(trialOrgInfo => {

        this.trialService.startExistingTrial(orgPrefix).subscribe(trial => {
        }, error => {
            //for now we are ignoring trial errors
          //this.handleError(error.error);
            console.log(error.error);
          });

        localStorage.setItem("trialOrgInfo", JSON.stringify(trialOrgInfo));
        this.router.navigate(["/pinnacleTrialConfirmation"]);

      }, error => {
        this.handleError(error.error);
      });

    });
  }

  handleError(errorMsg: string) {
    console.log(errorMsg);
    localStorage.setItem("error-message", JSON.stringify(errorMsg));
    //this will take user to post-logout redirect URL
    this.authService.startLogOut();
  }
}
